import type { IProduct } from '@monofront/types';

export const CATEGORIE = {
  STARTWITH: 'Catégorie_',
};

export const RAYON = {
  STARTWITH: 'Rayon_',
};

export const RAYONS = {
  ANIMALERIE: `${RAYON.STARTWITH}Animalerie`,
  COSMETIQUE_DIY: `${RAYON.STARTWITH}Cosmétique DIY`,
};

export const VALUE = {
  STARTWITH: 'Valeurs_',
};

export const DIET = {
  STARTWITH: 'Diet_',
};

export const VALUES = {
  MADEINFRANCE: 'FAIT EN FRANCE',
  ORIGINFRANCE: 'ORIGINE FRANCE',
  ZEROWASTE: 'ZÉRO DÉCHET',
  VEGAN: 'VEGAN',
  CRUELTYFREE: 'CRUELTY-FREE',
  DEMETER: 'DEMETER',
  ORIGINITALIY: '100% ITALIE',
  PRIVATELABEL: 'CRÉÉ PAR VOUS',
  FAIRTRADE: 'COMMERCE EQUITABLE',
  ANTIWASTE: 'ANTI-GASPI',
  RETURNABLEPACKAGING: 'PRODUIT CONSIGNÉ',
  FALLINGPRICE: 'PRIX EN BAISSE',
  FROZENPRICE: 'PRIX GELÉ',
};

export const VALUES_DE = {
  VEGAN: 'VEGAN',
  DEMETER: 'DEMETER',
  GLUTENFREE: 'GLUTENFREI',
  LACTOSEFREE: 'LAKTOSEFREI',
  MADEINGERMANY: 'AUS DEUTSCHER PRODUKTION',
  FAIRTRADE: 'FAIRTRADE',
  BIOLAND: 'BIOLAND',
  NATURLAND: 'NATURLAND',
  GERMAN: 'DEUTSCH',
  FAIRGEHANDELT: 'FAIR GEHANDELT',
};

export const VALUES_ORDER = {
  VEGAN: 0,
  'CRÉÉ PAR VOUS': 1,
  'ORIGINE FRANCE': 2,
  'FAIT EN FRANCE': 3,
  'ANTI-GASPI': 4,
  'ZÉRO DÉCHET': 5,
  'COMMERCE EQUITABLE': 6,
  DEMETER: 7,
  'PRODUIT CONSIGNÉ': 8,
  'CRUELTY-FREE': 9,
  '100% ITALIE': 10,
};

export const DIETS = {
  GLUTENFREE: 'SANS GLUTEN',
  NOSUGAR: 'SANS SUCRES AJOUTÉS',
  NOLACTOSE: 'SANS LACTOSE',
  VEGAN: 'VEGAN',
};

export const DIETS_ORDER = {
  VEGAN: 0,
  'SANS GLUTEN': 1,
  'SANS LACTOSE': 2,
  'SANS SUCRES AJOUTÉS': 3,
};

export const ANTIWASTES = {
  STARTWITH: 'Recup_',
};
export const ANTIWASTE = {
  ALL: `${ANTIWASTES.STARTWITH}Anti-gaspi`,
};

export const NEW = 'NEW';

export const FRESH = 'FRESH';

export const ULTRA_FRESH = 'ULTRA_FRESH';

export const EARLY_EXPIRATION = 'EARLY_EXPIRATION';

export const PRODUCT_MULTIPLE = {
  STARTWITH: 'product-multiple_',
};

export const CART_MAX_QUANTITY = {
  STARTWITH: 'cart-max-quantity-',
};

export const HIDDEN_PRICE = {
  STARTWITH: 'prix-masque',
};

export const PRODUCT_BUNDLE_RATE = {
  STARTWITH: 'product-bundle-rate-',
};

export const GIFT_ITEM_QUANTITY = {
  STARTWITH: 'first-order-gift-quantity-',
};

export const USER_DATA_TYPE = {
  COLOR_BANNER: 'color-banner' as const,
  PRODUCT_BASKET_CAROUSEL: 'product-basket-carousel' as const,
  MERCH_CARD: 'merch-card' as const,
  IMAGE_BANNER: 'image-banner' as const,
};

export const PRODUCT_TYPE = {
  BEAUTY_OLD: 'Beauté & Hygiène',
  BEAUTY: 'Beauté et Hygiène',
};

export const PRODUCT_SUBTYPE_DE = {
  ALCOHOL: 'Alkoholische Getränke',
  PETS: 'Garten & Tier',
};

export const NUTRITIONAL_VALUES_AS_TEXT = {
  TRUE: 'yes',
  FALSE: 'no',
};

export const BLOG_TAGS = {
  RECIPE: 'recette',
};

export const DEFAULT_SEARCH_PRODUCTS_INDEX = 'recently_ordered_count_desc';

export const ALGOLIA_PRODUCT_SORT_BY = {
  POPULARITY: 'recently_ordered_count_desc',
  PRICE_PER_UNIT_ASC: 'price_per_unit_asc',
  PRICE_PER_UNIT_DESC: 'price_per_unit_desc',
  PRICE_ASC: 'price_asc',
  PRICE_DESC: 'price_desc',
  DATE: 'published_at_desc',
  BEST_RATE: 'average_reviews_desc',
};

export const CHANNELS = {
  FR: 'default:fr_FR',
  DE: 'default:de_DE',
};

export const COLLECTION_TYPE_FILTER = {
  SECTION: 'type:section', // default collection
  VENDOR: 'type:vendor',
};

export const ORIGIN = {
  FRANCE: 'Origine France',
};

export const MADE_IN = {
  FRANCE: 'Fait en France',
};

export const ALGOLIA_FACET_VALUES = {
  'A-PLUS': 'A+',
};

export const ALGOLIA_GRADE_FACET_REGEX = /^(?:[a-f]|a-plus)$/i;

export enum ALGOLIA_INSIGHTS_EVENT_NAME {
  FILTER_CLICKED = 'Filter Clicked',

  // These should probably be merged in one
  PRODUCT_CLICKED = 'Product Clicked',
  SEARCH_RESULT_CLICKED = 'Search Result Clicked',
  CLICK_PRODUCT = 'Click product',

  PRODUCT_ADDED_TO_CART = 'Product Added to Cart',
}

export const MINIMUM_ADD_TO_CART_QUANTITY = 'minimum-cart-quantity_';

/**
 * Top-level Algolia attributes read when rendering the product page.
 *
 * Algolia retrieves nested objects wholesale, so the screens' nested reads
 * (`meta.finance.*`, `meta.marketing.*`, `meta.seo.*`,
 * `meta.logistics_dimensions.*`, `meta.reviews_stats.*`, `breadcrumb[].*`,
 * `images_with_alt[].*`, `vendor_collection.handle`) are covered by retaining
 * the whole top-level attribute. Keep it in
 * sync when a product-screen component starts reading a new product field.
 */
export const PRODUCT_PAGE_ATTRIBUTES_TO_RETRIEVE = [
  'objectID',
  'id',
  'sku',
  'handle',
  'title',
  'vendor',
  'vendor_collection',
  'product_type',
  'product_subtype',
  'price',
  'compare_at_price',
  'inventory_quantity',
  'inventory_available',
  'image',
  'images',
  'images_with_alt',
  'product_image',
  'tags',
  'values',
  'diets',
  'collection_titles',
  'breadcrumb',
  'combination_product_data',
  'shelf_life_at_reception',
  'barcode',
  'meta',
] as const satisfies readonly (keyof IProduct)[];

/** Union of the top-level product attributes fetched for the product page. */
export type ProductPageAttribute =
  (typeof PRODUCT_PAGE_ATTRIBUTES_TO_RETRIEVE)[number];

/**
 * The product shape actually returned by the product-screen fetch: `IProduct`
 * narrowed to {@link PRODUCT_PAGE_ATTRIBUTES_TO_RETRIEVE}. `meta` keeps its full
 * {@link IMeta} shape (Algolia returns the whole object), so nested reads such
 * as `meta.marketing.*` stay typed. Derived from the constant, so the type and
 * the `attributesToRetrieve` request can never drift apart.
 */
export type ProductPageProduct = Pick<IProduct, ProductPageAttribute>;
